import Layout from '@/components/Layout';
import { useMatchMedia } from '@/hooks/useMatchMedia';

import { ContactBox } from './components/ContactBox';
import { HelpItem } from './components/HelpItem';
import { SearchBar } from './components/SearchBar';
import * as S from './styles';

const TemplateCentralDeAjuda: React.FC = () => {
  const isScreenLessThan640 = useMatchMedia('(max-width: 640px)');

  return (
    <Layout>
      <S.Container>
        <S.Content>
          <div style={{ marginBottom: '6.1rem' }}>
            <S.PageTitle
              style={{ marginBottom: isScreenLessThan640 ? '2rem' : '5.8rem' }}
            >
              Como podemos te ajudar?
            </S.PageTitle>

            <SearchBar />
          </div>

          <S.HelpItemsGrid style={{ marginBottom: '9.2rem' }}>
            <HelpItem
              iconSrc="/icons/calendario.png"
              iconAlt="Ícone de calendário"
              title="Tenho uma dúvida sobre a realização do evento."
              description="Saiba mais detalhes do evento."
              href="/central-de-ajuda/tenho-uma-duvida-sobre-a-realizacao-do-evento"
            />

            <HelpItem
              iconSrc="/icons/wrong.png"
              iconAlt="Ícone de página"
              title="Como solicitar o cancelamento do seu pedido?"
              description="Sabia mais como realizar seu cancelamento de forma facil."
              href="/central-de-ajuda/como-solicitar-o-cancelamento-do-meu-pedido"
            />

            <HelpItem
              iconSrc="/icons/alterar.png"
              iconAlt="Ícone de alterar"
              title="Gostaria de alterar o setor do meu ingresso"
              description="Não realizamos esse tipo de procedimento."
              href="/central-de-ajuda/gostaria-de-alterar-o-setor-do-meu-ingresso"
            />

            <HelpItem
              iconSrc="/icons/forbidden.png"
              iconAlt="Ícone de dinhero"
              title="Me arrependi de um cancelamento que solicitei"
              description="A solicitação não pode ser desfeita."
              href="/central-de-ajuda/me-arrependi-de-um-cancelamento-que-solicitei"
              imgWidth={38}
              imgHeight={38}
            />

            <HelpItem
              iconSrc="/icons/change-management.png"
              iconAlt="Ícone de pessoas"
              title="Troca de Titularidade"
              description="Fique informado como trocar a titularidade de seus ingressos."
              href="/central-de-ajuda/troca-de-titularidade"
            />

            <HelpItem
              iconSrc="/icons/spam.png"
              iconAlt="Ícone de e-mail"
              title="Como ter acesso a meus ingressos?"
              description="Saiba como fazer o download dos vouchers"
              href="/central-de-ajuda/como-ter-acesso-a-meus-ingressos"
            />

            <HelpItem
              iconSrc="/icons/forbidden.png"
              iconAlt="Ícone de e-mail"
              title="Compra não aprovada/cancelada"
              description="Veja mais informações sobre compra não aprovada/cancelada."
              href="/central-de-ajuda/compra-nao-aprovada-cancelada"
            />

            <HelpItem
              iconSrc="/icons/bora.jpg"
              iconAlt="Bora tickets"
              title="Recebi uma cortesia eletrônica e não consigo acessar"
              description="Saiba como ter acesso a seu ingresso."
              href="/central-de-ajuda/nao-consigo-acessar-cortesia-eletronica"
            />

            <HelpItem
              iconSrc="/icons/bora.jpg"
              iconAlt="Ícone de atenção"
              title="Quem tem direito à meia entrada"
              description="Conheça os critérios e documentos necessários para meia entrada."
              href="/central-de-ajuda/quem-tem-direito-a-meia-entrada"
            />
          </S.HelpItemsGrid>

          <ContactBox />
        </S.Content>
      </S.Container>
    </Layout>
  );
};

export default TemplateCentralDeAjuda;
